export enum DecisionType {
    Upgrade,
    MakeTower,
    MakeBuilding,
    Wait,
    Move
}
